import { EditorView } from '@codemirror/view';

export const bearTheme = EditorView.theme({
  '&': {
    fontSize: '15px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", Arial, "Noto Sans KR", sans-serif',
    color: '#1A1A1A',
    backgroundColor: '#FFFFFF',
  },
  '.cm-content': {
    padding: '16px 0 60px',
    maxWidth: '100%',
    margin: '0',
    lineHeight: '1.75',
    caretColor: '#3B82F6',
  },
  '.cm-line': {
    padding: '2px 0',
  },
  '&.cm-focused .cm-cursor': {
    borderLeftColor: '#3B82F6',
    borderLeftWidth: '2px',
  },
  '&.cm-focused .cm-selectionBackground, .cm-selectionBackground': {
    backgroundColor: '#DBEAFE !important',
  },
  '.cm-gutters': {
    display: 'none',
  },
  '&.cm-focused': {
    outline: 'none',
  },
  '.cm-activeLine': {
    backgroundColor: 'transparent',
  },
  '.cm-activeLineGutter': {
    backgroundColor: 'transparent',
  },
});
